import { render, staticRenderFns } from "./SignDialog.vue?vue&type=template&id=f801d564&scoped=true"
import script from "./SignDialog.vue?vue&type=script&lang=js"
export * from "./SignDialog.vue?vue&type=script&lang=js"
import style0 from "./SignDialog.vue?vue&type=style&index=0&id=f801d564&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f801d564",
  null
  
)

export default component.exports